import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import PasswordInput from '../../ui/PasswordInput/PasswordInput'
import ActionButton from '../../ui/ActionButton/ActionButton'

const ButtonWrapper = styled.div`
  margin: 1rem 0 0;
`

const HorizontalStrengthIndicator = styled.div`
  height: 6px;
  background-color: var(--color-fg-lighter);
  width: 19%;
  margin-left: 1.25%;
  display: inline-block;
  &:first-child {
    margin-left: 0;
  }
`

const BulletStrength = styled.p`
  font-size: 12px;
  &:before {
    content: ' ';
    width: 14px;
    height: 14px;
    border-radius: 7px;
    background-color: var(
      ${({ error }) => (error ? '--color-fg-lighter' : '--color-primary')}
    );
    display: inline-block;
    margin-right: 5px;
    margin-bottom: -2px;
  }
`

const BulletStrengthTitle = styled.p`
  font-size: 12px;
`

const PasswordStrengthWrapper = styled.div`
  ${HorizontalStrengthIndicator}:nth-last-child(n+${({ validCount }) =>
  12 - validCount}) {
    background-color: var(--color-primary);
  }
`

const BlockButton = styled(ActionButton)`
  width: 100%;
`

function NominatePasswordForm(props) {
  const [changed, setChanged] = React.useState(false)

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    isSubmitting,
    isValid,
    disabled,
    method,
    action,
    newPassword,
  } = props

  const errorPasswordLength = changed ? errors.password_length : ' '
  const errorPasswordWithCapital = changed ? errors.password_with_capital : ' '
  const errorPasswordWithNumeric = changed ? errors.password_with_numeric : ' '
  const errorPasswordWithSymbol = changed ? errors.password_with_symbol : ' '
  const errorPasswordNotUncommon = changed ? errors.password_not_common : ' '

  let validCount = 0
  validCount += errorPasswordLength ? 0 : 1
  validCount += errorPasswordWithCapital ? 0 : 1
  validCount += errorPasswordWithNumeric ? 0 : 1
  validCount += errorPasswordWithSymbol ? 0 : 1
  validCount += errorPasswordNotUncommon ? 0 : 1

  return (
    <form onSubmit={handleSubmit} method={method} action={action}>
      <fieldset disabled={isSubmitting || disabled}>
        <PasswordInput
          name="password"
          placeholder={`Nominate ${newPassword ? 'New' : ''} Password`}
          initialValue={values.password}
          touched={touched.password}
          onChange={e => {
            setChanged(true)
            return handleChange(e)
          }}
          onBlur={handleBlur}
        />
        <PasswordInput
          name="confirm_password"
          placeholder="Confirm Password"
          initialValue={values.confirm_password}
          error={errors.confirm_password}
          touched={touched.confirm_password}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <PasswordStrengthWrapper validCount={validCount}>
          <HorizontalStrengthIndicator />
          <HorizontalStrengthIndicator />
          <HorizontalStrengthIndicator />
          <HorizontalStrengthIndicator />
          <HorizontalStrengthIndicator />
          <BulletStrengthTitle>Password must include:</BulletStrengthTitle>
          <BulletStrength error={errorPasswordLength}>
            At least 10 characters
          </BulletStrength>
          <BulletStrength error={errorPasswordWithCapital}>
            At least one capital letter
          </BulletStrength>
          <BulletStrength error={errorPasswordWithNumeric}>
            At least one number
          </BulletStrength>
          <BulletStrength error={errorPasswordWithSymbol}>
            At least one special character (!@#$%^)
          </BulletStrength>
          <BulletStrength error={errorPasswordNotUncommon}>
            Uncommon and non-obvious words (cannot be Password1! or Hello@123)
          </BulletStrength>
        </PasswordStrengthWrapper>
        <ButtonWrapper>
          <BlockButton type="submit" variant="primary" disabled={!isValid}>
            Next
          </BlockButton>
        </ButtonWrapper>
      </fieldset>
    </form>
  )
}

NominatePasswordForm.defaultProps = {
  handleSubmit: null,
  handleChange: null,
  handleBlur: null,
  values: {},
  errors: {},
  touched: {},
  isSubmitting: false,
  isValid: false,
  disabled: false,
  method: 'get',
  action: '',
}

NominatePasswordForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
  touched: PropTypes.shape(),
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  method: PropTypes.oneOf(['get', 'post']),
  action: PropTypes.string,
}

export default NominatePasswordForm
